import * as React from 'react';
import {ApolloProvider} from 'react-apollo';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {Router} from 'react-router-dom';

import {ApolloProvider as ReactHooksApolloProvider} from '@apollo/react-hooks';

import {nutApolloClient} from '../../../apollo-client';
import {appHistory} from '../../../history';
import {store} from '../../../store';

import {WhiteGloveThankYou} from './white-glove-thank-you';

export function mountWhiteGloveThankYou() {
    const whiteGloveThankYouContainer = document.querySelector(
        '#white-glove-thank-you-react-mount'
    );

    if (whiteGloveThankYouContainer) {
        ReactDOM.render(
            <Provider store={store}>
                <ApolloProvider client={nutApolloClient}>
                    <ReactHooksApolloProvider client={nutApolloClient}>
                        <Router history={appHistory}>
                            <WhiteGloveThankYou />
                        </Router>
                    </ReactHooksApolloProvider>
                </ApolloProvider>
            </Provider>,
            whiteGloveThankYouContainer
        );
    }
}
